var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.data.length<_vm.maxLen)?_c('span',[_c('span',{staticClass:"tj"},[_vm._v(_vm._s(_vm.data))])]):_c('span',[_c('span',{staticClass:"tj"},[_vm._v(_vm._s(_vm.showBtn?_vm.sliceStr:_vm.data)+"\n      "),_c('span',{staticClass:"btnWord",on:{"click":function($event){_vm.showBtn=!_vm.showBtn}}},[_vm._v(_vm._s(_vm.showBtn?_vm.tip:"收起"))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71317902","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/unfold.vue
// module id = 750
// module chunks = 163